var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_36519)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1.16699H3.33333C2.4496 1.16805 1.60237 1.51958 0.97748 2.14447C0.352588 2.76936 0.00105857 3.6166 0 4.50033L0 12.5003C0.00105857 13.3841 0.352588 14.2313 0.97748 14.8562C1.60237 15.4811 2.4496 15.8326 3.33333 15.8337H12.6667C13.5504 15.8326 14.3976 15.4811 15.0225 14.8562C15.6474 14.2313 15.9989 13.3841 16 12.5003V4.50033C15.9989 3.6166 15.6474 2.76936 15.0225 2.14447C14.3976 1.51958 13.5504 1.16805 12.6667 1.16699ZM3.33333 2.50033H12.6667C13.0659 2.50111 13.4557 2.62134 13.786 2.84553C14.1163 3.06972 14.3719 3.38762 14.52 3.75833L9.41467 8.86433C9.03895 9.23853 8.53028 9.44864 8 9.44864C7.46972 9.44864 6.96105 9.23853 6.58533 8.86433L1.48 3.75833C1.6281 3.38762 1.88374 3.06972 2.21403 2.84553C2.54432 2.62134 2.93414 2.50111 3.33333 2.50033ZM12.6667 14.5003H3.33333C2.8029 14.5003 2.29419 14.2896 1.91912 13.9145C1.54405 13.5395 1.33333 13.0308 1.33333 12.5003V5.50033L5.64267 9.80699C6.26842 10.4312 7.11617 10.7817 8 10.7817C8.88383 10.7817 9.73158 10.4312 10.3573 9.80699L14.6667 5.50033V12.5003C14.6667 13.0308 14.456 13.5395 14.0809 13.9145C13.7058 14.2896 13.1971 14.5003 12.6667 14.5003Z",
    fill: "#04151F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_36519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.d45be082b3dfe1920c461330605c63f5.svg";
export { ForwardRef as ReactComponent };